import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";
import { PaginationTypes } from "@Shared/Pagination-Types";

export const TabsSettings = [
  { label: "Layout", value: "layout", i18n: "layout" },
  { label: "Content", value: "content", i18n: "content" },
];

export const ContentLoadSettings = [
  { label: "Dynamic", value: "dynamic", i18n: "dynamic" },
  { label: "Manual", value: "manually", i18n: "manual" },
];

export const getOptionsToSelectUsersBy = (t) => ([
  { label: t("cosmos-collection"), value: true },
  { label: t("confluence-group"), value: false },
]);

export const PeopleVariants = {
  CARD: "card",
  LIST: "list",
};

export const getVariantOptions = (t) => [
  { label: t("card"), value: PeopleVariants.CARD },
  { label: t("list"), value: PeopleVariants.LIST },
];

export const getPaginationOptions = (t) => ([
  { label: t("none"), value: PaginationTypes.NONE },
  { label: t("show-more"), value: PaginationTypes.INFINITE },
  { label: t("previous-or-next"), value: PaginationTypes.CAROUSEL },
]);

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 32 },
];
